export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11445.a46cc4e6.jpg";